export const mapboxConfig = {
    publicToken: "pk.eyJ1IjoidW1haXIyMzEiLCJhIjoiY21sN2picjNwMG5jMzNmc2NuNzEyZW1rciJ9.s1W7GEGCV3vMKctiKqEvUQ",
    privateToken: "sk.eyJ1IjoidW1haXIyMzEiLCJhIjoiY21sN2pxc2R4MG44bjNmczI3dnd2MTQzYiJ9.eZnw9kUERSsZXjxsZAfiXg"
};
